/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';
import { MessageEntity } from './types';

interface State {
  readonly data?: MessageEntity[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: (conversationID: string) => Promise<void>;
}

export default function useDataAPIGetMessagesByConversationID(
  conversationID?: string
): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(conversationID: string): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getMessagesByConversationID(conversationID);

      setState({ isLoading: false, data });
    } catch (error: any) {
      setState({ isLoading: false, error });
    }
  }

  useEffect(() => {
    if (!conversationID) return;

    fetch(conversationID);
  }, [conversationID]);

  return { ...state, refetch: fetch };
}
